import {gql} from 'apollo-angular';
import {baseResponseGraphqlField} from '../../../../base.graphql';

export const UPDATE_CITIZEN_PASSWORD = gql`
mutation UpdateCitizenPassword($citizenUniqueId: String!,$userPassword: String!) {
    updateCitizenPassword(citizenUniqueId: $citizenUniqueId,userPassword:$userPassword) {
    ${baseResponseGraphqlField}
  }
}
`;
